<!--
Author: TangChen
Date: 2018-09-17
Desc: 菜单组件，由index.js 配置引入
-->
<template>
    <div class="comp-menu comp">
        <el-menu
            :default-active="menuCheck"
            class="el-menu-out"
            mode="horizontal"
            :unique-opened="true"
            router
        >
            <el-row class="comp-menu-list">
                <el-col v-for="item of menus" :key="item.i" :span="4">
                    <el-submenu v-if="item.menu" :index="item.i" popper-class="comp-menu-popup">
                        <template slot="title">
                            <!-- <i :class="item.icon"  aria-hidden="true" ></i> -->
                            <!-- <icon-combo :data="icon" :iconCla="item.icon"></icon-combo> -->
                            <span>{{ item.name }}</span>
                        </template>
                        <template v-if="item.menu">
                            <template v-for="items in item.menu">
                                <el-menu-item
                                    v-if="
                                        (info.isCC === '1' || items.link !== '/profitqry') &&
                                        (info.isCC === '1' || items.link !== '/service') &&
                                        (info.isCC === '1' || items.link !== '/statement') &&
                                        (info.isetf === '1' || items.link !== '/etflist') &&
                                        items.link !== '/optional' &&
                                        items.link !== '/helpService' &&
                                        items.link !== '/gongmu_fund' &&
                                        items.link !== '/simu_fund'
                                    "
                                    :key="items.name"
                                    :index="items.link"
                                >
                                    {{ items.name }}
                                </el-menu-item>
                                <el-menu-item
                                    v-if="items.name == '我的自选'"
                                    :key="items.name"
                                    :index="items.link"
                                >
                                    <a
                                        class="custom_title"
                                        :href="$cache.getCompanyInfoParam('10101006') + '/home/'"
                                        target="_blank"
                                    >
                                        我的自选
                                    </a>
                                </el-menu-item>
                                <el-menu-item
                                    v-if="items.name == '帮助与客服'"
                                    :key="items.name"
                                    :index="items.link"
                                >
                                    <a
                                        class="custom_title"
                                        :href="
                                            $cache.getCompanyInfoParam('10101006') + '/home/help/'
                                        "
                                        target="_blank"
                                    >
                                        帮助与客服
                                    </a>
                                </el-menu-item>
                                <el-menu-item
                                    v-if="items.name == '基金超市'"
                                    :key="items.name"
                                    :index="items.link"
                                >
                                    <a
                                        class="custom_title"
                                        :href="
                                            $cache.getCompanyInfoParam('10101006') + '/gongmu_fund'
                                        "
                                        target="_blank"
                                    >
                                        基金超市
                                    </a>
                                </el-menu-item>
                                <el-menu-item
                                    v-if="items.name == '高端理财'"
                                    :key="items.name"
                                    :index="items.link"
                                >
                                    <a
                                        class="custom_title"
                                        :href="
                                            $cache.getCompanyInfoParam('10101006') + '/simu_fund'
                                        "
                                        target="_blank"
                                    >
                                        高端理财
                                    </a>
                                </el-menu-item>
                            </template>
                        </template>
                    </el-submenu>
                    <el-menu-item v-else :index="item.link" class="grouped">
                        <!-- <icon-combo :data="icon" :iconCla="item.icon"></icon-combo> -->
                        <span slot="title">{{ item.name }}</span>
                    </el-menu-item>
                </el-col>
            </el-row>
        </el-menu>
    </div>
</template>
<script>
export default {
    name: "NavMenu",
    props: {
        active: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            menus: [
                {
                    icon: "fa fa-home",
                    name: "资产首页",
                    i: "1",
                    menu: [
                        { name: "我的资产", link: "/home" },
                        { name: "交易记录", link: "/traderecord" },
                        { name: "分红信息明细", link: "/dividendInfo" },
                        { name: "我的合同", link: "/mycontract" }
                        // { name: "快速交易", link: "/quickTrade" },
                        // { name: "分红管理", link: "/dividendInfo" },
                        // { name: "账户管理", link: "/acctManager" },
                        // { name: "信息中心", link: "/info" }
                    ]
                },
                // {
                //     icon: "fa fa-jpy",
                //     name: "现金宝",
                //     i: "2",
                //     link: "/currencyfund"
                // },
                // {
                //     icon: "fa fa-jpy",
                //     name: "大成钱柜",
                //     i: "2",
                //     link: "/moneyBox"
                // },
                {
                    icon: "fa fa-shopping-cart",
                    name: "基金交易",
                    i: "3",
                    link: "/quickTrade",
                    menu: [
                        { name: "我的自选", link: "/optional" },
                        { name: "基金超市", link: "/gongmu_fund" },
                        { name: "高端理财", link: "/simu_fund" }
                        // { name: "交易记录", link: "/traderecord" },
                        // { name: "分红信息明细", link: "/dividendInfo" },
                        // { name: "我的合同", link: "/mycontract" }
                    ]
                },
                {
                    icon: "fa fa-chart-line",
                    name: "基金定投",
                    i: "4",
                    menu: [
                        // { name: "定投产品", link: "/gfund/glist" },
                        { name: "我的定投", link: "/myplan" }
                    ]
                },
                // {
                //     icon: "fa fa-gem",
                //     name: "养老专区",
                //     i: "5",
                //     link: ""
                // },
                // {
                //     icon: "fa fa-gem",
                //     name: "专户理财",
                //     i: "5",
                //     menu: [
                //         { name: "专户理财产品", link: "/privatefund" },
                //         { name: "我的专户理财", link: "/private" },
                //         { name: "信息披露", link: "/infoPublish" }
                //     ]
                // },
                {
                    icon: "fa fa-user",
                    name: "个人中心",
                    i: "6",
                    menu: [
                        { name: "信息中心", link: "/info" },
                        { name: "帮助与客服", link: "/helpService" }
                        // { name: "我的银行卡", link: "/bank" },
                        // { name: "风险测评", link: "/risk" },
                        // { name: "安全中心", link: "/securitycenter" },
                        // { name: "服务定制", link: "/service" },
                        // { name: "对账单信息", link: "/statement" },
                        // { name: "投资者信息收集", link: "/infoCollection" },
                        // { name: "投资者转换", link: "/invchange" },
                        // { name: "个人税收居民类型声明", link: "/info/taxeslist" },
                        // { name: "政策法规", link: "/policyAndLaw" }
                    ]
                }
            ],
            icon: {
                w: "24"
            },
            menuCheck: "/home",
            info: {}
        };
    },
    mounted() {
        if (!this.$util.xjbIsOpen()) {
            this.menus = this.menus.filter((item) => {
                return item.i !== "2";
            });
        }
        // if(this.$cache.getXjbCode() === ""){
        //     this.menus = this.menus.filter(item=>{
        //         return item.i !== "2";
        //     });
        // }
        this.info = this.$cache.getUser();
        // 获取当前选中菜单
        const _x = this.$route.path;
        // 菜单自动选中
        this.menuCheck = _x;
    },
    methods: {}
};
</script>
<style lang="scss">
@import "../../assets/css/varibles";
.comp-menu {
    outline: none !important;
    .comp-menu-list {
        display: flex;
        justify-content: flex-end;
    }
    .el-menu.el-menu-out {
        outline: none !important;
        border: none;
        width: 950px;
        margin: 0 auto;
        background: inherit;
        .el-row {
            outline: none;
        }
        .el-menu-item.grouped,
        .el-submenu .el-submenu__title {
            height: auto;
            font-weight: 500;
            font-size: $f20;
            // margin: 0 10px;
            color: $text-color2;
            line-height: 52px;
            width: 140px;
            height: 52px;
            border-radius: 4px;
            display: flex;
            i {
                color: inherit;
                display: inline-block;
                text-align: center;
            }
            span {
                display: inline-block;
                line-height: 52px;
            }
            &:hover {
                background: #ffecec;
                border-color: $color-a-m;
                color: $bg18;
                i {
                    color: $bg18 !important;
                }
            }
        }
        .el-menu-item.grouped span {
            width: 140px;
        }
        .el-menu-item.is-active,
        .el-submenu.is-active .el-submenu__title {
            border-color: $color-a-m;
            color: $bg18;
            background: #ffecec;
            i {
                color: $bg18 !important;
            }
        }
    }
    .el-icon-arrow-down:before {
        content: "\E790" !important;
    }
    .el-submenu__icon-arrow {
        font-size: 16px !important;
    }
    .el-submenu__title i {
        color: #333 !important;
    }
}
li.el-menu-item.grouped {
    text-align: center;
}
.el-menu--horizontal.comp-menu-popup .el-menu.el-menu--popup.el-menu--popup-bottom-start {
    text-align: center;
    left: -12px;
    top: 9.2px;
    padding: 18px 0;
    min-width: 170px;
    font-size: $f16;
}
.el-menu--horizontal.comp-menu-popup .el-menu--popup {
    border-radius: 2px 20px 2px 20px !important;
}
.el-menu-item {
    .custom_title {
        color: #333;
        &:hover {
            color: $bg18;
        }
    }
}
</style>
